var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
let order = 1;
function kuJiaLePostMessage(message) {
  const { action } = message;
  const _order = order++;
  const retPromise = new Promise((resolve) => {
    function addMessageFun(event) {
      if (event.data.action === action && event.data._order === _order) {
        window.removeEventListener("message", addMessageFun);
        resolve(event.data.value);
      }
    }
    window.addEventListener("message", addMessageFun);
  });
  window.parent.postMessage(__spreadProps(__spreadValues({}, message), { _order }), "*");
  return retPromise;
}
export { kuJiaLePostMessage };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/kuJiaLePostMessage.js